<template>
  <div class="simple-upload-demo">
    <el-card>
      <div slot="header">
        <h3>文件上传 - 简单示例</h3>
      </div>

      <!-- WebP 配置选项 -->
      <el-row :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="8">
          <div class="config-item">
            <label>WebP 转换:</label>
            <el-switch
              v-model="uploadConfig.convertToWebP"
              active-text="启用"
              inactive-text="禁用"
            ></el-switch>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="config-item">
            <label>WebP 质量:</label>
            <el-select
              v-model="uploadConfig.webpQuality"
              :disabled="!uploadConfig.convertToWebP"
              placeholder="选择质量"
              style="width: 100%"
            >
              <el-option label="高质量 (适合专业摄影)" value="high"></el-option>
              <el-option label="中等质量 (推荐)" value="medium"></el-option>
              <el-option label="低质量 (适合缩略图)" value="low"></el-option>
              <el-option label="最小体积 (适合图标)" value="smallest"></el-option>
              <el-option label="极限压缩" value="extreme"></el-option>
            </el-select>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="config-item">
            <label>存储桶:</label>
            <el-input value="kanbei" disabled></el-input>
          </div>
        </el-col>
      </el-row>

      <!-- 当前配置显示 -->
      <el-alert type="info" :closable="false" style="margin-bottom: 20px;">
        <div>
          <strong>当前配置：</strong>
          存储桶=kanbei |
          WebP转换={{ uploadConfig.convertToWebP ? '启用' : '禁用' }} |
          质量={{ uploadConfig.webpQuality }}
        </div>
      </el-alert>

      <!-- 图片上传 -->
      <ImageUpload
        v-model="imageUrls"
        :convert-to-web-p="uploadConfig.convertToWebP"
        :webp-quality="uploadConfig.webpQuality"
        bucket="kanbei"
        :limit="5"
      />

      <!-- 上传结果 -->
      <div v-if="imageUrls" style="margin-top: 20px;">
        <el-divider>上传结果</el-divider>
        <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px;">{{ imageUrls }}</pre>
      </div>
    </el-card>
  </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload'

export default {
  name: 'SimpleUploadDemo',
  components: {
    ImageUpload
  },
  data() {
    return {
      uploadConfig: {
        convertToWebP: false,
        webpQuality: 'medium'
      },
      imageUrls: ''
    }
  },
  watch: {
    'uploadConfig.convertToWebP'(val) {
      console.log('WebP转换:', val ? '启用' : '禁用')
    },
    'uploadConfig.webpQuality'(val) {
      console.log('质量设置:', val)
    }
  }
}
</script>

<style scoped>
.simple-upload-demo {
  padding: 20px;
}

.config-item {
  margin-bottom: 10px;
}

.config-item label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #606266;
}
</style>
